// extracted by mini-css-extract-plugin
module.exports = {"link":"_7a3fb80146--link--GZK8a"};